import s from './style.module.scss';
import { Modal, Spin } from 'antd';
import MyIcon from '@/components/MyIcon';
import { Display } from '@/components/Display/Display';
import MindMap from '@/components/MindMap';
import { useState } from 'react';
import GrtButton from '@/components/Web/GrtButton';
import AIMarks from '@/components/AiMark';
let defaulDetail = {
    resource_name: '',
    template_ids: [],
    template_names: [],
    keywords: [],
    mind_map_summary_list: [],
    paragraph_summary: ''
};

const CourseDetail = (props) => {
    const { clickLearn, detail = defaulDetail } = props;
    const [mindOpen, setMindOpen] = useState(false);
    //思维导图打开
    const onMindOpen = () => {
        setMindOpen(true);
    };
    //思维导图关闭
    const onCloseMind = () => {
        setMindOpen(false);
    };

    const handleClickLearn = () => {
        console.log(detail, '详情');
        clickLearn(detail.resource_id);
    };
    return (
        <div className={[`${s['modal-box']} ${s['course-detail-box']}`]}>
            {/* 思维导图放大 */}
            <Modal centered width={1000} title="" maskClosable={false} footer={null} open={mindOpen} onCancel={onCloseMind}>
                <div style={{ height: 600, display: 'flex', justifyContent: 'center' }}>
                    <MindMap
                        mindMapSummaryListData={detail?.mind_map_summary_list}
                        width={950}
                        height={550}
                        courseName={detail?.resource_name}
                        size="14"
                        markStyle={{ position: 'absolute', right: '-6px', bottom: '-10px' }}
                    ></MindMap>
                </div>
            </Modal>

            <div className={s['modal-action']}>
                <span className={s['title']}>视频详情</span>
                <span
                    className={s['close']}
                    onClick={() => {
                        props?.onClose();
                    }}
                >
                    <MyIcon type="icon-a-guanbi31"></MyIcon>
                </span>
            </div>

            <div className={s['content-wrap']}>
                <div className={s['course-title']}>{detail?.resource_name}</div>
                <div className={s['business-type']}>所属业务：{detail?.template_names?.join('、')}</div>
                <div className={s['scroll-box']}>
                    <Display show={detail?.keywords && detail?.keywords.length}>
                        <>
                            <div className={s['type-title']}>关键词</div>
                            <div className={s['key-word']}>
                                {detail?.keywords.map((ele, index) => {
                                    return <span key={index}>{ele}</span>;
                                })}
                            </div>
                        </>
                    </Display>
                    <Display show={detail?.paragraph_summary}>
                        <>
                            <div className={s['type-title']}>视频摘要</div>
                            <div className={s['summary']}>{detail?.paragraph_summary}</div>
                        </>
                    </Display>
                    <Display show={detail?.mind_map_summary_list && detail?.mind_map_summary_list.length}>
                        <>
                            <div className={s['type-title']}>思维导图</div>
                            <div className={s['mind-wrap']} onClick={onMindOpen}>
                                <div className={s['mask']}></div>
                                <MindMap
                                    mindMapSummaryListData={detail?.mind_map_summary_list}
                                    width={380}
                                    courseName={detail?.resource_name}
                                    size="14"
                                ></MindMap>
                            </div>
                        </>
                    </Display>
                </div>
                <div className={s['footer-wrap']}>
                    <GrtButton type="primary" onClick={handleClickLearn}>
                        立即学习
                    </GrtButton>
                </div>
            </div>
        </div>
    );
};

export default CourseDetail;
